import React from "react";
import useOnlineStatus from "../hooks/useOnlineStatus";

export default function OfflineBanner() {
    const isOnline = useOnlineStatus();

    if (isOnline) return (
        <div style={{
            backgroundColor: '#00aa00',
            color: '#fff',
            padding: '8px 16px',
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: '14px',
            position: 'sticky',
            top: 0,
            zIndex: 1050
        }}>
            ONLINE
        </div>
    );;

    return (
        <div style={{
            backgroundColor: '#dc3545',
            color: '#fff',
            padding: '8px 16px',
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: '14px',
            position: 'sticky',
            top: 0,
            zIndex: 1050
        }}>
            Nincs internet, bizonyos funkciók korlátozottan érhetőek el.
        </div>
    );
}
